// IndexedDB keystore for the NC1 identity — the browser twin of Windows'
// DPAPI keystore. Holds the UNWRAPPED identity secrets once the user has
// unlocked (at signup, via passkey PRF, device-transfer, or recovery code),
// so steady-state page loads decrypt without prompting.
//
// Same at-rest posture as Virgil e3kit's IndexedDB private-key store today.
// Note Account.vue's clearAllIndexedDB() (account deletion/reset) wipes this
// too — by design; the identity re-enters via passkey/transfer/recovery.

import localforage from 'localforage'

const store = localforage.createInstance({
  name: 'nc1-keystore',
})

const identityKey = (accountId) => `identity.${accountId}`

/**
 * secrets = { id_enc_pk, id_enc_sk, id_sign_pk, id_sign_sk, identity_version }
 * (the exact snake_case shape the §7.1 wraps protect).
 */
export async function saveIdentity(accountId, { secrets, altAccountId, email }) {
  await store.setItem(identityKey(accountId), {
    secrets,
    altAccountId,
    email,
    savedAt: Date.now(),
  })
}

export async function loadIdentity(accountId) {
  return await store.getItem(identityKey(accountId))
}

export async function clearIdentity(accountId) {
  await store.removeItem(identityKey(accountId))
}

// ---- local passkey marker ---------------------------------------------------
// WebAuthn has no silent "is one of these credentials usable here?" query, so
// at registration time we remember which credential THIS browser minted. Lets
// the UI say "a passkey protects this device ✓" instead of offering to mint a
// duplicate. Best-effort: cleared storage just means the UI offers Add again.

const passkeyKey = (accountId) => `passkey.${accountId}`

export async function recordLocalPasskey(accountId, credentialIdB64) {
  await store.setItem(passkeyKey(accountId), {
    credentialIdB64,
    registeredAt: Date.now(),
  })
}

export async function getLocalPasskey(accountId) {
  return await store.getItem(passkeyKey(accountId))
}
